// Campus photo for /colleges/touro-university: CC BY 2.0, by Ajay Suresh from New York, NY, USA, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ATouro_College_(48128100127).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/touro-university/; credited under the photo.
const photo = {
    "slug": "touro-university",
    "alt": "A Touro building with a large Welcome to Touro College sign on its wall in Hell's Kitchen, New York City",
    "src": "/colleges/touro-university/campus-1600.webp",
    "srcSmall": "/colleges/touro-university/campus-800.webp",
    "srcMid": "/colleges/touro-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/touro-university/og.jpg",
    "title": "Touro College (48128100127)",
    "author": "Ajay Suresh from New York, NY, USA",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ATouro_College_(48128100127).jpg",
    "read": "2026-10-02"
};

export default photo;
